'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { Button } from '@personly/libs-widgets';
import { useSuspensions } from '@personly/libs-providers';
import { useEmails } from '@/providers/emails';
import { useTextareas } from '@/providers/textareas';
interface Props {
  children: string;
}
const TicketSubmitButton = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    email
  } = useEmails();
  const {
    textarea
  } = useTextareas();
  const {
    suspended
  } = useSuspensions();
  const blocked = suspended("CREATE_TICKET") === "STARTED";
  const disabled = !email || !textarea || blocked;
  let t1;
  if ($[0] !== children || $[1] !== disabled) {
    t1 = <Button disabled={disabled} block={true} type="submit">{children}</Button>;
    $[0] = children;
    $[1] = disabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default TicketSubmitButton;